module.exports = __webpack_public_path__ + "static/media/hotelPageBoardingIcon.0f1b7ce7.png";